<!-- Mobile header (full). -->
<section *ngIf="isMobile && showFullHeader" class="mobileFullHeader zk-mt-20">
</section>
<!-- /mobileSingleHeader. -->

<!-- Mobile header (light). -->
<section *ngIf="isMobile && !showFullHeader" class="mobileSingleHeader">
	<img class="mnuIcon" src="/assets/images/icons/clients.svg" />
	<span class="pageTitle">{{ 'PAGES.CLIENTS.ADDNEW' | translate }}</span>
	<fa-icon icon="times" class="times" (click)="goToList()"></fa-icon>
</section>
<!-- /mobileSingleHeader. -->

<!-- Desktop. -->
<div
	*ngIf="!isLoading"
	class="container-fluid schedule-container schedule-desktop"
	(window:resize)="onResize()"
	[@enterAnimation]
>
	<div class="row">
		<!-- MAIN CONTENT ============================================================= -->

		<section class="clientsContainer" [ngClass]="{ 'col-md-9': !isMobile }">
			<!-- Add new client. -->
			<app-clientsadd
				*ngIf="activeSection === pagesList.Add"
				(cancelAddClient)="cancelAddClient($event)"
			></app-clientsadd>

			<!-- Client details. -->
			<app-clientsdetails
				*ngIf="activeSection === pagesList.Details"
				(editClient)="editClient($event)"
				(newAppointment)="newAppointment($event)"
				(showAllClients)="goToList()"
				(showEventDetails)="showEventDetails($event)"
			></app-clientsdetails>

			<!-- Edit a client. -->
			<app-clientsedit
				*ngIf="activeSection === pagesList.Edit"
				(cancelEditClient)="cancelAddClient()"
			></app-clientsedit>
		</section>

		<!-- SIDEBAR ================================================================== -->

		<div class="col-md-3">
			<!-- Profile Completion -->
			<!--Data validation -->
			<div class="row">
				<div class="col-xs-12 sidebar-widget">
					<app-alert-info-status
						class="bank-alert-container"
					></app-alert-info-status>
				</div>
			</div>
			<div class="row">
				<div class="col-xs-12 sidebar-widget">
					<app-profile-completion
						[reset]="resetProfileCompletion"
						[hideDetails]="showHideDetails"
					></app-profile-completion>
				</div>
			</div>
					<!-- Show appointments of a day. -->
		<div class="row">
			<div class="col-xs-12 sidebar-widget">
				<appointment-preview-list
					*ngIf="!isMobile && sidebarVisible == 'Appointments'"
					[activeSidebar]="activeSidebar"
					[selectedMode]="selectedMode"
					(showTodayEvents)="changeActiveSidebar($event)"
					(showEvent)="changeActiveSidebar($event)"
				></appointment-preview-list>
			</div>
		</div>
		</div>

		<!-- Show appointment details. -->
		<app-details
			*ngIf="!isMobile && modalVisible === 1"
			[activeSidebar]="activeSidebar"
			(showEvents)="changeActiveSidebar($event)"
			(rescheduleEvent)="reschedule($event)"
		></app-details>

		<appointment-details-sidebar 
			[isVisible]="modalVisible === 4"
			[activeSidebar]="activeSidebar"
			(schedulNewSessionEvent)="newAppointment($event)"
			(rescheduleEvent)="reschedule($event)"
			(showEvents)="changeActiveSidebar($event)"
		></appointment-details-sidebar>

		<!-- Show form modal -->
		<appointment-sidebar
		></appointment-sidebar>

	</div>
</div>

<!-- Loader. -->
<section *ngIf="isLoading" style="text-align: center; margin: 40px 0">
	<freud-loader size="sm" [bgColor]="false"></freud-loader>
</section>
